/* eslint-disable no-extra-boolean-cast */
import React from 'react';
import { Button } from 'module-tsl-ui-elements';
import { getFromContext } from '../AlertFiltersContext';
import { AuthHelper, createSearchParams, mzTrack, saveFacets } from '../helpers';

export const AlertCTA = () => {
  const { state, dispatch } = getFromContext();
  const {
    id,
    prefix,
    i18n: { country },
    onAlertChange,
    facets,
  } = state;

  const onCancel = () => {
    if (id) {
      state.onAlertChange('Close');
    } else {
      state.onAlertChange('Cancel');

      dispatch({
        type: 'warn',
        value: { isCanceled: true },
      });
    }
  };

  const saveAlert = async () => {
    const body = createSearchParams(state);
    const response = await saveFacets(body, country, id);

    switch (response.status) {
      case 'duplicate': {
        dispatch({
          type: 'error',
          value: 'duplicate',
        });

        return onAlertChange('NotSaved');
      }
      case 'success': {
        dispatch({
          type: 'save',
          value: { isSaved: true },
        });

        return onAlertChange('Saved', response.id, body);
      }
      case 'error':
      default: {
        dispatch({
          type: 'error',
          value: 'error',
        });

        return onAlertChange('NotSaved');
      }
    }
  };

  const authenticate = new AuthHelper(
    () => mzTrack('CLICK', 'save-alert'),
    () => saveAlert(),
  );

  const onSave = () => {
    authenticate.run();
  };

  const onDelete = async () => {
    dispatch({
      type: 'warn',
      value: { isDeleted: true },
    });
  };

  return (
    <div className={`${prefix}__cta`}>
      <Button theme="primary" isBlock onClick={onSave} disabled={facets.length === 0}>
        Save
      </Button>
      <Button theme="secondary" isBlock onClick={onCancel}>
        Cancel
      </Button>
      {Boolean(id) && (
        <Button theme="primary-warning" onClick={onDelete}>
          Delete
        </Button>
      )}
    </div>
  );
};
